module.exports = __webpack_public_path__ + "img/footer-kv.43243335.png";